import { useEffect, useLayoutEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { MOBILE_QUERY } from "hooks/useDetectMobile";

import useAssistantPanelStore from "../useStore";
import { RESPONSIVE_BREAKPOINT } from "../constants";

const useAssistantPanelResponsiveVariant = () => {
  const {
    initializeAssistantPanel,
    onScreenBreakpointChange,
    enterFullscreen,
    clampFloatingToViewport,
  } = useAssistantPanelStore(
    useShallow((state) => ({
      initializeAssistantPanel: state.initialize,
      onScreenBreakpointChange: state.onScreenBreakpointChange,
      enterFullscreen: state.enterFullscreen,
      clampFloatingToViewport: state.clampFloatingToViewport,
    }))
  );

  useLayoutEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${RESPONSIVE_BREAKPOINT}px)`);
    const mobileQuery = window.matchMedia(MOBILE_QUERY);

    initializeAssistantPanel(mediaQuery.matches, mobileQuery.matches);

    const handleMediaChange = (event: MediaQueryListEvent) => {
      onScreenBreakpointChange(event.matches);
    };

    const handleMobileChange = (event: MediaQueryListEvent) => {
      if (event.matches) {
        enterFullscreen();
      }
    };

    mediaQuery.addEventListener("change", handleMediaChange);
    mobileQuery.addEventListener("change", handleMobileChange);

    return () => {
      mediaQuery.removeEventListener("change", handleMediaChange);
      mobileQuery.removeEventListener("change", handleMobileChange);
    };
  }, [initializeAssistantPanel, onScreenBreakpointChange, enterFullscreen]);

  useEffect(() => {
    clampFloatingToViewport();

    window.addEventListener("resize", clampFloatingToViewport);

    return () => {
      window.removeEventListener("resize", clampFloatingToViewport);
    };
  }, [clampFloatingToViewport]);
};

export default useAssistantPanelResponsiveVariant;
